import { ValueOf } from './util';

/** 取引種別のenum */
export const EDealType = {
  SALES: '売上',
  CANCEL: '返品',
} as const;

export type DealTypeKey = keyof typeof EDealType;
export type DealTypeValue = ValueOf<typeof EDealType>;

export const dealTypeKeys = Object.keys(EDealType) as (DealTypeKey[]);

/** v-select用items */
export const dealTypeItems = dealTypeKeys
  .map((key) => ({
    title: EDealType[key],
    value: key,
  }));
